module.exports = __webpack_public_path__ + "static/media/GettyImages-173046609.23c6659.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/GettyImages-173046609.mp4
// module id = zd/Q
// module chunks = 1